import { Cpu, Github, Linkedin, Twitter } from 'lucide-react';

const SOLUTIONS_LINKS = [
  { name: 'Financial Services', href: '#financial' },
  { name: 'Healthcare', href: '#healthcare' },
  { name: 'Retail Operations', href: '#retail' },
  { name: 'Travel & Hospitality', href: '#travel' },
] as const;

const COMPANY_LINKS = [
  { name: 'About Us', href: '#' },
  { name: 'Careers', href: '#' },
  { name: 'Security', href: '#' },
  { name: 'Contact', href: '#' },
] as const;

const SOCIAL_LINKS = [
  { name: 'GitHub', icon: Github, href: '#' },
  { name: 'Twitter', icon: Twitter, href: '#' },
  { name: 'LinkedIn', icon: Linkedin, href: '#' },
] as const;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center mb-4">
              <Cpu className="h-6 w-6 text-brand-500 mr-2" aria-hidden="true" />
              <span className="font-bold text-xl text-white">OmniFlow</span>
            </div>
            <p className="text-sm text-slate-400">
              Powering the next generation of automated business logic with compliance, security,
              and intelligence.
            </p>
          </div>

          <nav aria-label="Solutions">
            <h4 className="text-white font-semibold mb-4">Solutions</h4>
            <ul className="space-y-2 text-sm">
              {SOLUTIONS_LINKS.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="hover:text-brand-400 transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Company">
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              {COMPANY_LINKS.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="hover:text-brand-400 transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-white font-semibold mb-4">Connect</h4>
            <div className="flex space-x-4">
              {SOCIAL_LINKS.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="hover:text-white transition-colors"
                  aria-label={`Follow us on ${link.name}`}
                >
                  <link.icon size={20} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center text-xs text-slate-500">
          © {currentYear} OmniFlow Solutions. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
